import { get } from './http'

const Operate = {
  queryAppList: (params) => {
    return get('/operate/frontend/thread/appstore/gets', params)
  }
}
export default Operate